<template>
  <v-dialog v-model="dialog" width="400" height="800">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        color="#ffffff"
        class="btn-739eec"
        width="112"
        height="38"
      >
        회사선택
      </v-btn>
    </template>
    <v-card class="max-height-600 ">
      <v-card-title class="text-h5 back-556C96 justify-center lighten-2">
        <h4 class="color-white">회사선택</h4>
      </v-card-title>
      <v-row class="ma-0 pt-5 pa-0">
        <div class="ma-0 pa-0 pl-5 width-200">
          <v-select
            solo
            dense
            hide-details
            :items="typeList"
            v-model="companyTypes"
            placeholder="선택해주세요"
            :menu-props="{ offsetY: true }"
          />
        </div>
      </v-row>
      <v-card-text class="justify-center d-flex ">
        <perfect-scrollbar style="max-height:360px" class="mt-3">
          <v-radio-group v-model="company" v-if="companyList">
            <v-radio
              color="primary"
              class="width-float pa-2 pr-5"
              v-for="list in companyList"
              :key="list.companyId"
              :label="list.companyName"
              :value="list"
            >
            </v-radio>
          </v-radio-group>
        </perfect-scrollbar>
      </v-card-text>
      <v-card-actions class="justify-center align-center pb-5">
        <v-btn
          color="#739EEC"
          class="color-white"
          width="150"
          height="40"
          @click="selectCompany"
        >
          선택완료
        </v-btn>
        <v-btn color="#eeeeee" width="150" height="40" @click="dialog = false">
          닫기
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CompanyApi from "@/api/CompanyService";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
export default {
  components: {
    PerfectScrollbar,
  },

  props: ["statement", "companyType"],

  async created() {
    let data = { constructionId: null };
    let returnData = await CompanyApi.companyTotalList(data);
    this.companyList = returnData.data.companyList;
  },

  watch: {
    companyType: async function(companyType) {
      if (companyType) {
        let data = { constructionId: null };
        this.companyTypes = companyType;
        let returnData = await CompanyApi.companyTotalList(data);
        this.companyList = returnData.data.companyList.filter(
          (companyList) => companyList.companyType == companyType
        );
      }
    },

    companyTypes: async function(companyType) {
      if (companyType) {
        let data = { constructionId: null };
        let returnData = await CompanyApi.companyTotalList(data);
        this.companyList = returnData.data.companyList.filter(
          (companyList) => companyList.companyType == companyType
        );
      }
    },
  },

  data: function() {
    return {
      dialog: false,
      companyList: [],
      company: "",
      companyTypes: "",
      typeList: ["가공업체", "샵업체", "관리자"],
    };
  },

  methods: {
    selectCompany() {
      this.dialog = false;
      this.$bus.$emit("sendCompany", this.company);
    },
  },
};
</script>
<style scoped>
.back-3F557D {
  background: #3f557d;
}
.width-200 {
  width: 200px;
}
</style>
